module.exports = __webpack_public_path__ + "static/img/IMG_20151222_183813.db719ceb.jpg";